import {createAsyncThunk} from "@reduxjs/toolkit";
import {searchApi} from "../../../api/searchApi";
import offlineOrTimeoutPromise from "../utils/offlineOrTimeoutPromise";

export const drugSearchAutocompleteThunk = createAsyncThunk('enhancedSearch/drugSearchAutocomplete', async (arg) => {
  const {
    searchText
  } = arg;

  const suggestionApiPromise = searchApi.drugSearchAutocomplete(searchText);

  return Promise.race([suggestionApiPromise, offlineOrTimeoutPromise()]);
})
